import { css, type SerializedStyles } from '@emotion/react';

import { styleguideColors, styleguideFontSize, styleguideFontWeight } from '@/Client/Styles/kaiShikiTokens';
import { styleguideFontFamily, styleguideLetterSpacing, styleguideSpacing } from '@kaiizen/kai-shiki/core';

/** Shared by every Super Admin tools tab, so they read as one tool. */
export type SuperAdminToolsPanelStyles = {
  panel: SerializedStyles;
  heading: SerializedStyles;
  description: SerializedStyles;
  row: SerializedStyles;
  label: SerializedStyles;
  value: SerializedStyles;
  success: SerializedStyles;
  error: SerializedStyles;
  actions: SerializedStyles;
  textArea: SerializedStyles;
};

export const DEFAULT_SUPER_ADMIN_TOOLS_PANEL_STYLES: SuperAdminToolsPanelStyles = {
  panel: css`
    label: SUPER_ADMIN_TOOLS_PANEL;
    display: flex;
    flex-direction: column;
    gap: ${styleguideSpacing.s4}px;
    padding: ${styleguideSpacing.s5}px;
    max-width: 720px;
    font-family: ${styleguideFontFamily.body};
    font-size: ${styleguideFontSize.bodyMedium}px;
    color: ${styleguideColors.ink};
  `,
  heading: css`
    label: SUPER_ADMIN_TOOLS_PANEL_HEADING;
    font-family: ${styleguideFontFamily.display};
    font-size: ${styleguideFontSize.displaySmall}px;
  `,
  description: css`
    label: SUPER_ADMIN_TOOLS_PANEL_DESCRIPTION;
    color: ${styleguideColors.textSecondary};
  `,
  row: css`
    label: SUPER_ADMIN_TOOLS_PANEL_ROW;
    display: grid;
    grid-template-columns: 180px 1fr;
    gap: ${styleguideSpacing.s3}px;
    align-items: baseline;
    padding: ${styleguideSpacing.s2}px 0;
    border-bottom: 1px solid ${styleguideColors.stroke};
  `,
  label: css`
    label: SUPER_ADMIN_TOOLS_PANEL_LABEL;
    font-family: ${styleguideFontFamily.mono};
    font-size: ${styleguideFontSize.monoLabel}px;
    letter-spacing: ${styleguideLetterSpacing.monoCaption};
    text-transform: uppercase;
    color: ${styleguideColors.textTertiary};
  `,
  value: css`
    label: SUPER_ADMIN_TOOLS_PANEL_VALUE;
    overflow-wrap: anywhere;
  `,
  success: css`
    label: SUPER_ADMIN_TOOLS_PANEL_SUCCESS;
    color: ${styleguideColors.success};
    font-weight: ${styleguideFontWeight.bold};
  `,
  error: css`
    label: SUPER_ADMIN_TOOLS_PANEL_ERROR;
    color: ${styleguideColors.error};
    font-weight: ${styleguideFontWeight.bold};
  `,
  actions: css`
    label: SUPER_ADMIN_TOOLS_PANEL_ACTIONS;
    display: flex;
    gap: ${styleguideSpacing.s3}px;
    align-items: center;
  `,
  textArea: css`
    label: SUPER_ADMIN_TOOLS_PANEL_TEXT_AREA;
    box-sizing: border-box;
    width: 100%;
    min-height: 160px;
    padding: ${styleguideSpacing.s3}px;
    font-family: ${styleguideFontFamily.mono};
    font-size: ${styleguideFontSize.bodyMedium}px;
    color: ${styleguideColors.ink};
    border: 1px solid ${styleguideColors.stroke};
    resize: vertical;
  `,
};
